import { useEffect } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { customer_request_list } from "../../../../../Studio-Services/Studio_Services";
import { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { ClientListTable } from "./ClientListTable";
import { writeFile, utils } from "xlsx";

export const Clientoflist = () => {

  const [dataArray, setDataArray] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [arrow, setArrow] = useState(true);
  const [statusFilter, setStatusFilter] = useState("All");

  const [visibleCount, setVisibleCount] = useState(10);

  const visibleData = tableData.slice(0, visibleCount);

  const [loader, setLoader] = useState(false);

  function sortByNameZA(filteredData) {
    return filteredData.slice().sort((a, b) => {
      const nameA = a.myName.toLowerCase();
      const nameB = b.myName.toLowerCase();
      if (nameA > nameB) return -1;
      if (nameA < nameB) return 1;
      return 0;
    });
  }

  function sortByNameAZ(filteredData) {
    return filteredData.slice().sort((a, b) => {
      const nameA = a.myName.toLowerCase();
      const nameB = b.myName.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  }

  const filterByStatus = (status) => {
    if (status === "All") {
      setTableData(dataArray);
      return;
    }
    const filtered_data = dataArray.filter(
      (item) =>
        String(item.Status || "").toLowerCase() ===
        status.toLowerCase()
    );

    setTableData(filtered_data);
  };

  const filterData = (data) => {
    if (typeof data !== "string") {
      return []; // or return an empty array or throw an error, based on your requirement
    }
    let fData = dataArray.filter((item) => {
      const myNameLower = item.myName.toLowerCase();
      const statusLower = item.Status.toLowerCase();
      const genderLower = item.Gender.toLowerCase();
      const startDateLower = item.dob.toLowerCase();

      const dataLower = data.toLowerCase();

      const statusMatch = statusLower.startsWith(dataLower);
      const genderMatch = genderLower.startsWith(dataLower);
      const startDateMatch = startDateLower.startsWith(dataLower);

      const myNameMatch = myNameLower.startsWith(dataLower);

      return statusMatch || genderMatch || startDateMatch || myNameMatch;
    });
    return fData;
  };

  const searchHandler = (e) => {
    const value = e.target.value;
    if (value) {
      const resp = filterData(value);
      setTableData(resp);
    } else {
      setTableData(dataArray);
    }
  }

  const handleDownloadClick = (requestData) => {
    let temporary = []
    temporary.push(["Full Name", "Email", "Mobile", "Status"]);
    requestData.forEach((value) => {
      temporary.push([
        value.myName,
        value.Email,
        value.mobile,
        value.Status === "Deactive" ? "Inactive" : value.Status,
      ]);
    });

    const worksheet = utils.aoa_to_sheet(temporary);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Client List Sheet 1");

    writeFile(workbook, "Customer_export.xlsx");
  };



  const shortHandler = (data) => {
    let resp = data;
    setArrow(!arrow);
    if (arrow) {
      resp = sortByNameZA(data);
      setTableData(resp);
    } else {
      resp = sortByNameAZ(data);
    }
    setTableData(resp);
  }


  const getClientList = async () => {
    const pid = { 'pageid': '1', 'page_data_limit': '10' };
    let abcd = [];
    setLoader(true);
    try {
      const resp = await customer_request_list(pid);
      if (resp) {
        resp.data.forEach((element) => {
          abcd.push({
            Name: (
              <>
                <Link to='/studio-customer-profile' state={{ id: element.id }} style={{ cursor: 'pointer' }}>
                  <img className="img-fluid table_user" src={element.profile_img} alt='' />
                  <span className="ps-4">{element.name}</span>
                </Link>
              </>
            ),
            myName: element.name,
            dob: element.date_of_birth ? moment(element.date_of_birth).format("DD MMM YYYY") : "",
            Email: element.myEmail,
            mobile: element.mobile,
            Age: element.age,
            Gender: element.gender,
            Start_Date: element.reg_date ? moment.unix(element.reg_date).format('DD-MMM-YYYY') : "",
            Status: element.user_status,
          });
        });
        setDataArray(abcd);
        if (abcd && abcd.length > 0) {
          const sortedData = sortByNameAZ(abcd)
          setDataArray(sortedData);
          setTableData(sortedData);
        }
      } else {
        setDataArray(abcd)
      };
    } catch (error) {
      console.log("----@Error-----", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getClientList();
  }, []);
  return (
    <>
      {loader &&
        <div className='MainLoader'>
          <Spinner animation="border" role="status" className='Loader' />
        </div>
      }
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />
                <section className="addClient innerContent">
                  <div className="AddClientContent">
                    <Container fluid>
                      <Row className="mt-3 clinet-list-tab">
                        <Col>
                          <ClientListTable
                            dataArray={dataArray}
                            tableData={tableData}
                            arrow={arrow}
                            handleDownloadClick={handleDownloadClick}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                            filterByStatus={filterByStatus}
                            searchHandler={searchHandler}
                            shortHandler={shortHandler}
                            setVisibleCount={setVisibleCount}
                            visibleCount={visibleCount}
                          />
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
